import React, { Fragment, useEffect, useState } from "react";
import Sidebar from "../Common/Components/Sidebar";
import Filters from "../Devices/Filter";
import Dashboard from "../Common/Components/Dashboard";
import Widget from "../Common/Components/widget";
import AlarmStatisticsGridWidget from "./AlarmStatisticsGridWidget";
import AlarmStatisticsChartWidget from "./AlarmStatisticsChartWidget";
import AlarmScopeChartWidget from "./AlarmScopeChartWidget";
import AlarmScopeGridWidget from "./AlarmScopeGridWidget";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import AlarmFilters from "./AlarmFilter";
import ChartOptions from "./AlarmChartOptions";
import {countColor,durationColor} from "../Common/Constants"
import DashboardOptions from "../Common/Components/DashboardOptions"
import AlarmDetailsWidget from "./AlarmDetailsWidget";
import { useAppDispatch } from "../Core/store.hooks";
import { fetchAlarmDatas, fetchAlarmDatasWithScope } from "./Slice";
import { fetchMachineTimes } from "../MachineTimes/slice";

interface AlarmOverviewProps {}

const AlarmOverview = (props: AlarmOverviewProps) => {

    const dispatch = useAppDispatch();
    const params = useSelector(getParamsSelector);
    useEffect(() => {
        if (params != null) {
            dispatch(fetchAlarmDatas(params));
            dispatch(fetchAlarmDatasWithScope(params));
            dispatch(fetchMachineTimes(params));
        }
    }, [params]);
    const positionData = 
        [{ col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 6 },
        { col: 4, colSpan: 3, rowSpan: 6 }];

    const sidebarItems = [
        {title: "Filters", item:<Filters id="1" scopeOrderInput={true} deviceWithSerialInput ="hidden"/>, expanded: true},
        {title:"Alarm Text", item:<AlarmFilters id="2"/>, expanded:true},
        {title:"Chart Options", item:<ChartOptions id="3"/>,expanded:true},
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ];

    const renderWidgets = () =>{
        if (params.alarmText != null){
            return (
                <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                    <AlarmScopeGridWidget id = "alarmScopeGrid" header = "Alarm Statistics" />
                    <AlarmScopeChartWidget id = "alarmCountChart" header ="Alarm Counts" values ="count" series={{name:"scoped count",unit:"Count",color:countColor}}/>
                    <AlarmScopeChartWidget id = "alarmDurationchart" header ="Alarm Durations" values ="duration" series={{name:"scoped duration",unit:"Hours",color:durationColor}}/>
                    <AlarmDetailsWidget id="alarmDetailsTable" header="Alarm Details"/>
                </Dashboard>
            )
        }else{
            return (
                <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                    <AlarmStatisticsChartWidget id="3" header="Alarm Text Counts" values="count" series={{name:"Alarm count", unit:"Count", color:countColor}}/>
                    <AlarmStatisticsChartWidget id="4" header="Alarm Text Durations" values="duration" series={{name:"Alarm Duration", unit:"Hours", color:durationColor}}/>
                    <AlarmScopeChartWidget id = "5" header ="Alarm Counts" values ="count" series={{name:"Alarm count",unit:"Count",color:countColor}}/>
                    <AlarmScopeChartWidget id = "6" header ="Alarm Durations" values ="duration" series={{name:"Alarm duration",unit:"Hours",color:durationColor}}/>
                    <AlarmStatisticsGridWidget id="1" header="Alarm text Statistics" />
                    <AlarmScopeGridWidget id = "2" header = "Alarm Statistics" />
                </Dashboard>
            )
        }
    }

    return (
        <Fragment>
            {renderWidgets()}
        </Fragment>
    )
};

export default AlarmOverview;
